import React from "react";

export default function TablesPanel() {
  return <div>TablesPanel</div>;
}
